
    import Vue from "vue";
    import Component from "vue-class-component";
    import { settings } from "@/main.ts";
    import {logoService} from "@/LogoService";

    @Component
    export default class AppFooter extends Vue {
        termsAndConditionsUrl = settings.termsAndConditionsUrl;
        currentYear = new Date().getFullYear();
        
        getLogo() {
            const useColor = true;
            return logoService.getLogoName(useColor);
        }
    }
